import { render } from "./education_survey.vue?vue&type=template&id=3533b3a4"
import script from "./education_survey.vue?vue&type=script&lang=js"
export * from "./education_survey.vue?vue&type=script&lang=js"

import "./education_survey.vue?vue&type=style&index=0&id=3533b3a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__